/**
 * Source type values corresponding to the source field in location payloads.
 */
export const SOURCE_SMS = 'sms';
export const SOURCE_RCS = 'rcs';
export const SOURCE_MMS = 'mms';
export const SOURCE_CALL = 'call';
export const SOURCE_TCAPI = 'tcapi';
export const SOURCE_ADMIN_SMS = 'admin_sms';

export type LocationSources =
  | typeof SOURCE_SMS
  | typeof SOURCE_RCS
  | typeof SOURCE_MMS
  | typeof SOURCE_CALL
  | typeof SOURCE_TCAPI
  | typeof SOURCE_ADMIN_SMS;
